<h4>{{ list.config.title }}</h4>

<nb-actions>
  <nb-action *ngIf="list.totalElements > 0">
    {{ translations.writeCount }}
    {{ list.totalElements.toLocaleString() }}
  </nb-action>

  <nb-action *ngIf="list.configuration.allowSearch && !list.configuration.searchEnabled" i18n-nbTooltip="@@Filter" (click)="list.toggleSearch()" nbTooltip="Фильтр" icon="search-outline"></nb-action>

  <nb-action *ngIf="list.configuration.allowSearch && list.configuration.searchEnabled" i18n-nbTooltip="@@Filter" (click)="list.toggleSearch()" nbTooltip="Очистить фильтр" icon="circle-x"></nb-action>

  <nb-action i18n-nbTooltip="@@ExcelExport" nbTooltip="Экспорт в Excel" *ngIf="!list.config.downloadEnable" (click)="list.exportToExcel()" icon="download-outline"></nb-action>

  <nb-action i18n-nbTooltip="@@ExportXlsx" nbTooltip="Экспорт в Excel" *ngIf="list.config.downloadEnable" (click)="list.exportToXlsx()" icon="download-outline"></nb-action>

  <nb-action *ngIf="list.config.uriCreate !== null" [routerLink]="list.config.uriCreate || ['create']" i18n-nbTooltip="@@AddRecord" nbTooltip="Добавить запись" icon="plus-outline"></nb-action>

  <nb-action *ngIf="list.config.softDelete" (click)="list.toggleDeleted()" i18n-nbTooltip="@@ShowDeleted" nbTooltip="Показать удаленные" [icon]="list.showDeleted ? 'eye' : 'eye-closed'"></nb-action>

  <nb-action>
    <ng-content select="[customAction]"></ng-content>
  </nb-action>

  <nb-action>
    <grid-gear [list]="list"/>
  </nb-action>
</nb-actions>
